import { NavLink } from "react-router-dom";
import { nav_links } from "../data";

export function DesktopNav() {
  return (
    <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
      {nav_links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          data-testid={`nav-${l.label.toLowerCase()}`}
          className={({ isActive }) =>
            `font-mono text-[12px] tracking-[0.18em] uppercase px-3 py-2 transition-colors ${
              isActive ? "text-signal-amber" : "text-textmain hover:text-signal-amber"
            }`
          }
          end={l.to === "/"}
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function MobileNav({ onCta }) {
  return (
    <div className="lg:hidden border-t border-ink-700 bg-ink-950" data-testid="mobile-nav">
      <div className="section-padding py-4 flex flex-col">
        {nav_links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            className={({ isActive }) =>
              `font-mono text-xs tracking-[0.2em] uppercase py-3 border-b border-ink-700 ${
                isActive ? "text-signal-amber" : "text-textmain"
              }`
            }
            end={l.to === "/"}
          >
            {l.label}
          </NavLink>
        ))}
        {onCta}
      </div>
    </div>
  );
}
